const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = TPL => {
  new BLOCKS;
};

class BLOCKS {
  constructor() {
    this.mainvisual();
    this.initButtonHandler(); 
    this.initHeaderToggle();
    this.initMenuCloseHandler();
    this.initFoxAnimation(); 
    this.initOnkanAnimation();
    this.initAnchorCleanup();
  }
  
  mainvisual () {
    console.log('Mainvisual Animation Start'); 

    const mainvisual = document.querySelector('.mainvisual');
    if (mainvisual) {
        const pictures = mainvisual.querySelectorAll('.mainvisual_wrap_tree picture');
        
        pictures.forEach((picture, index) => {
            const delay = 50 + (index * 200);
            setTimeout(() => {
                picture.classList.add('is-visible');
            }, delay);
        });
    }

    const titlePart = document.querySelector('.mainvisual_wrap_parts .parts_ttl');
    if (titlePart) {
        const delayTime = 500; 
        setTimeout(() => {
            titlePart.classList.add('is-fadein');
        }, delayTime);
    }
  }

  initButtonHandler() {
    const button = document.querySelector('.mainvisual_wrap_btn button');
    const container = document.querySelector('.mainvisual_wrap_btn');

    if (button && container) {
        button.addEventListener('click', function() {
            container.classList.add('is-hidden');
        });
    }
  }

  initHeaderToggle() {
      const header = document.getElementById('header');
      const hamburgerBtn = document.getElementById('hamburger-btn');
      const scrollThreshold = 200; 

      if (!header || !hamburgerBtn) {
          return;
      }

      const handleScroll = () => {
        const scrollY = w.scrollY; 
        
        if (scrollY > scrollThreshold) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
          
          header.classList.remove('is-open'); 
          hamburgerBtn.setAttribute('aria-expanded', false); 
        }
      };

      w.addEventListener('scroll', handleScroll); 
      
      handleScroll(); 

      const handleMediaChange = () => {
          handleScroll();
      };
      mq.addEventListener('change', handleMediaChange); 
      

      hamburgerBtn.addEventListener('click', () => {
        if (!header.classList.contains('is-scrolled')) {
        }
        
        header.classList.toggle('is-open');
        const isExpanded = header.classList.contains('is-open');
        hamburgerBtn.setAttribute('aria-expanded', isExpanded); 
      });
  }

  initMenuCloseHandler() {
    const header = document.getElementById('header');
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const spNav = document.getElementById('sp-nav');
    
    if (!header || !hamburgerBtn || !spNav) {
        return;
    }

    const closeMenu = () => {
        header.classList.remove('is-open');
        hamburgerBtn.setAttribute('aria-expanded', false);
    };

    d.addEventListener('click', (event) => {
        if (!header.classList.contains('is-open')) {
            return;
        }

        if (!hamburgerBtn.contains(event.target) && !spNav.contains(event.target)) {
            closeMenu();
        }
    });

    const spNavLinks = spNav.querySelectorAll('a');
    spNavLinks.forEach(link => {
        link.addEventListener('click', () => {
            closeMenu();
        });
    });
  }

  initFoxAnimation() {
    const foxElement = document.querySelector('.aboutus_wrap_img .fox');

    if (!foxElement) {
        return;
    }

    const options = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.9 
    };

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible'); 
          
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, options);
    
    observer.observe(foxElement);

    console.log('Fox Animation Observer Initialized'); 
  }

  initOnkanAnimation() {
    const targetElement = document.querySelector('.course_onkan_wrap_parts picture:first-child');
    
    if (!targetElement) {
        return;
    }
    
    const options = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.8
    };

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-slide-in'); 
          
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, options);
    
    observer.observe(targetElement);

    console.log('Onkan Animation Observer Initialized'); 
  }

  initAnchorCleanup() {
    if (window.location.hash) {
      console.log(`URLフラグメント "${window.location.hash}" を削除します`);
      
      history.replaceState(
        null, 
        null, 
        window.location.pathname + window.location.search
      );
    }
  }
}

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
}